/*
  form_validation
*/
/**
 * Desktop/Mobile form validation script
 */

 /************************************************
 		GET ALL MESSAGES FOR THE CURRENT PAGE
    method from bundle.js
 *************************************************/
if (typeof group !== "undefined") { //group is from bundle.js, in group.js
  var MESSAGES = group.select(PAGE_CODE_NAME).Messages;
}
//-- if no messages found (probably when on WL side)
//-- get messages from OPTIONS inputs
if (typeof MESSAGES === "undefined") {

  //-- init
  var MESSAGES = [];

  //-- get all inputs
  var group_options_inputs = $("input[data-kind=GROUP_MESSAGE]");

  //-- assemble them into an object
  group_options_inputs.each(function() {
    //-- init
    var message_object = {};

    //-- get data
    var option = $(this);
    var option_type = option.attr("data-type");
    var option_code = option.attr("data-code");
    var option_val = option.val();

    //-- construct message object
    message_object.Message_Type = option_type;
    message_object.Message_Code = option_code;
    message_object.Val = option_val;

    MESSAGES.push(message_object);
  });



}


/************************************************
		GET AVAILABLE FORMS ON THE PAGE
    GET THEIR REQUIRED ITEMS
    ADD MISSING HTML STRUCTURE IF NEEDED
    VALIDATE
*************************************************/
var __FORM = {

  /**
   * createMessageItem - create a message to display
   * @param {STRING} code - error code
   * @param {STRING} val - error code value
   * @return {OBJECT}
   */
  createMessageItem: function(code, val) {
    return $("<li class='message-item' data-code='"+code+"'><span class='message-text'>"+val+"</span></li>");
  },


  /**
   * validate_form - main function for validating a form
   * @param {OBJECT} form_obj - jquery object
   * @param {bool} shadow - if true, won't display errors
   * @return {BOOLEAN}
   */
  validate_form: function(form_obj, shadow) {

    //-- init
    var _form_details = __FORM.getFormInfo(form_obj);
    var _form_items = _form_details.items;
    var _form_submit = form_obj.find("[type=submit]");
    var validated = true;

    if (typeof _form_items !== "undefined") {

      //-- go through registered items
      _form_items.forEach(function(item) {

        //-- get actuel item form form
        var item_obj = form_obj.find("[name='"+item.name+"']");

        //-- get erros test cases for this item
        var errors = item.errors;

        //-- add indicator that this item has changed
        if (!shadow) {
          __FORM.changed(item_obj);
        }

        //-- go through items
        errors.forEach(function(error) {

          //-- test if item pass error function
          if (error.test(item_obj)) {

            //-- display error if not shadow
            if (!shadow) {
              __FORM.displayError(item_obj, error.code);
            }

            //item_obj.focus();
            validated = false;
          }
          else {
            //-- remove error

            if (!shadow) {
              __FORM.removeError(item_obj, error.code);
            }
          }
        });
      });

      if (validated) {
        _form_submit.removeAttr('disabled');
        _form_submit.removeClass('disabled');
      }
      else {
        _form_submit.addClass('disabled');
        _form_submit.attr('disabled', '');
      }
    }
    else {
      console.error("cannot validate this form", _form_details, form_obj);
    }

    //-- send response to form
    return validated;
  },

  /**
   * validate - main function
   * @param {OBJECT} form_obj - jquery object
   * @return {BOOLEAN}
   */
  validate_item: function(item_obj) {

    //-- validate only if item_obj has already changed
    if (!__FORM.hasChanged(item_obj)) {
      return; //stop script
    }

    //-- init
    var form_details_item_selected = "";
    var validated = true;
    var form_obj = item_obj.parents("form"); //get form of the item
    var form_details = __FORM.getFormInfo(form_obj);
    var form_details_items = form_details.items;

    if (typeof form_details === "undefined" || !form_details) return; // end script of no details found


    //-- get item info from form details
    form_details_item_selected = $.grep(form_details_items, function(item) {
      return item.name === item_obj.attr("name");
    })[0];

    //-- in info about item has been retrieved
    if (typeof form_details_item_selected !== "undefined" && form_details_item_selected !== "") {

      //-- get erros test cases for this item
      var errors = form_details_item_selected.errors;

      errors.forEach(function(error) {

        if (error.test(item_obj)) {
          //-- display error
          __FORM.displayError(item_obj, error.code);

          validated = false;
        }
        else {
          //-- remove error
          __FORM.removeError(item_obj, error.code);
        }
      });
    }
    else {
      console.error("cannot validate this form", form_details, form_obj);
    }
  },


  /**
   * format_structure - goes through all the forms and format the html STRUCTURE to accept errors messages
   * @return {VOID}
   */
  formatStructure: function() {
    var message_wrapper_structure = '<div class="messages-wrapper">'+
      '<ul class="messages-list">'+
      '</ul>'+
    '</div>';

    $("form").each(function() {

      //-- get module of the form
      var form_module = $(this).parents("[data-type=module]");

      //-- its required items
      var form_items = $(this).find("[data-required]");

      //-- test if form requires VALIDATION
      if (form_items.length > 0) {
        //-- make form items wrapper the same width as them
        form_items.each(function() {

          //-- init
          var _this = $(this);

          //-- get it's type
          var type = _this.attr("type");

          //-- it type==file, take the fake button instead of the input file
          if (type === "file") {
            _this =  _this.parents("form").find(".attach_btn");
          }

          //-- get item wrapper
          var parent_el = _this.parent();

          //-- get item width to assign it to its wrapper (except when input type = file)
          if (form_module.is('[class^=mob]')) {
            parent_el.css("width", "100%");
          }
          else {
            if (type === "file") {
              parent_el.width(_this.outerWidth());

              //-- temporary fix for WL side on UK (don't know why but the script assign a value far too big on WL side)
              if (_this.outerWidth() > 215) {
                parent_el.width("215");
              }
            }
            else {
              parent_el.width(_this.outerWidth());
            }
          }

          //-- needed css property
          parent_el.css("box-sizing", "content-box");

          //-- assign messages structure to item wrapper
          parent_el.append($(message_wrapper_structure));
        });
      }
    });
  },


  /**
   * getFormInfo - get details about a form in FORMS_INFO
   * @param {OBJECT} form - jquery object
   * @return {MIXED}
   */
  getFormInfo: function(form) {
    //-- get selected form name, then search for its details
    var form_name = form.attr("name");
    var found = false;

    FORMS_INFO.forEach(function(f) {
      if (form_name === f.form_name) found = f;
    });
    return found;
  },


  /**
   * getErrorValue - get details about message via its error code (feeded by WL DB)
   * @param {STRING} err_code - error code
   * @return {MIXED}
   */
  getErrorValue: function(err_code) {
    var found = false;
    //-- get value of error_code from DB
    MESSAGES.forEach(function(m) {
      if (m.Message_Type === "error" && m.Message_Code === err_code) found = m.Val;
    });
    return found;
  },


  /**
   * displayError - display error for the selected item
   * @param {OBJECT} item - jquery object
   * @param {STRING} error_val - error value for the item
   * @return {VOID}
   */
  displayError: function(item, error_code) {
    //-- get value of error_code from DB
    var error_val = __FORM.getErrorValue(error_code);

    //-- process if db response is correct
    if (error_val && typeof error_val !== "undefined" && error_val !== "") {
      //-- get item wrapper
      var item_wrapper = item.parent();

      //-- get messages list & items
      var msg_list = item_wrapper.find(".messages-list");
      var msg_items = msg_list.find(".message-item");

      //-- check if error is already displayed
      var found_msg_items = false;
      msg_items.each(function() {
        var item = $(this);
        if (item.attr("data-code") == error_code) {
          found_msg_items = true;
        }
      });

      //-- if not exist yet, create the new error and add it the list
      if (!found_msg_items) {
        var new_item = __FORM.createMessageItem(error_code, error_val);
        msg_list.append(new_item);
      }

      __FORM.setItemStatus(item, "error");
    }
    else {
      console.error("couldn't validate:", item.attr("name"), "database may be missing an association", FORMS_INFO);
    }
  },


  /**
   * removeError - remove error for the selected item
   * @param {OBJECT} item - jquery object
   * @param {STRING} error_val - error value for the item
   * @return {VOID}
   */
  removeError: function(item, error_code) {
    //-- get item wrapper
    var item_wrapper = item.parent();

    //-- get messages list & items
    var msg_list = item_wrapper.find(".messages-list");
    var msg_items = msg_list.find(".message-item");

    //-- check if error is already displayed
    var found_msg_item = false;
    msg_items.each(function() {
      var item = $(this);
      if (item.attr("data-code") == error_code) {
        found_msg_item = item;
      }
    });

    //-- if not exist yet, create the new error and add it the list
    if (found_msg_item.length > 0) {
      found_msg_item.remove();
    }

    __FORM.setItemStatus(item, "correct");
  },


  /**
   * changed - inform the dom that this item is dirty
   * @param {OBJECT} item - form input, select...
   * @return {VOID}
   */
  changed: function(item) {
    item.removeClass("dirty").addClass("dirty");
  },


  /**
   * hasChanged - check is an item has changed
   * @param {OBJECT} item - form input, select...
   * @return {BOOL}
   */
  hasChanged: function(item) {
    return item.hasClass("dirty");
  },


  /**
   * setItemStatus - show item status when using the form
   * @param {OBJECT} item - form input, select...
   * @param {STRING} status - status to display
   * @return {VOID}
   */
  setItemStatus: function(item, status) {

    //-- get wrapper & status icon element (known as "addon")
    var item_wrapper = item.parent();
    var addon = item_wrapper.find(".addon.animatedIcon");

    //-- if status is already set
    var wrapperHasCLass = item_wrapper.hasClass(STATUS_TO_CLASS[status].wrapper);
    var addonHasClass = addon.hasClass(STATUS_TO_CLASS[status].addon);

    //-- clear
    if (!wrapperHasCLass && STATUS_TO_CLASS[status].wrapper !== "") __FORM.clearItemStatus(item, "wrapper", "all");
    if (!addonHasClass && STATUS_TO_CLASS[status].addon !== "") __FORM.clearItemStatus(item, "addon", "all");

    //-- add the classes link to the status
    if (!wrapperHasCLass) item_wrapper.addClass(STATUS_TO_CLASS[status].wrapper);
    if (!addonHasClass) addon.addClass(STATUS_TO_CLASS[status].addon).show();
  },
  /**
   * clearItemStatus - clear all status of an item
   * @param {OBJECT} item - form input, select...
   * @param {STRING} which - "addon" or "wrapper" or "all"
   * @param {STRING} status - "all" or a specific status
   * @return {VOID}
   */
  clearItemStatus: function(item, which, status) {
    //-- init
    var all_wrapper_class = "writing error correct info";
    var all_addon_class = "icon_writing icon_error icon_correct icon_calendar icon_info";
    var item_wrapper = item.parent();
    var addon = item_wrapper.find(".addon.animatedIcon");
    var selected_wrapper_class = "";
    var selected_addon_class = "";

    if (status === "all") {
      selected_wrapper_class = all_wrapper_class;
      selected_addon_class = all_addon_class;
    }
    else {
      selected_wrapper_class = STATUS_TO_CLASS[status].wrapper;
      selected_addon_class = STATUS_TO_CLASS[status].addon;
    }

    if (which == "wrapper") item_wrapper.removeClass(selected_wrapper_class); //clear addon wrapper classes as well
    else if (which == "addon")   addon.removeClass(selected_addon_class);
    else {
      item_wrapper.removeClass(selected_wrapper_class); //clear addon wrapper classes as well
      addon.removeClass(selected_addon_class);
    }
  }
};






//-- initiate
__FORM.formatStructure();




/************************************************
	VALIDATE FORMS ON SUBMIT EVENT HANDLER
*************************************************/
$(document.body).on("click", "form [type=submit]", function(e) {

  //-- if validation ok
  if (__FORM.validate_form($(this).parents("form"), false)) {
    return;
  }
  //-- else cancel submit
  else {
    e.preventDefault(e);
  }
});


/************************************************
	VALIDATE FORM ITEMS ON CLICK/BLUR OR CHANGE
  Add "dirty" indicator on items after they are "touched"
*************************************************/
$(document.body).on("change", "form [data-required]", function(e) {
  __FORM.changed($(this)); //add indicator that this item has changed
});
$(document.body).on("click blur change", "form [data-required]", function(e) {
  __FORM.validate_item($(this));
  __FORM.validate_form($(this).parents("form"), true); //to active input submit or not
});
$(document.body).on("change", "form [data-required][type=file]", function(e) {
  __FORM.validate_item($(this));
  __FORM.validate_form($(this).parents("form"), true); //to active input submit or not
});
$(document.body).on("click", "form [data-required]:not([type=file])", function(e) {
  __FORM.setItemStatus($(this), "writing");
});
$(document.body).on("blur", "form [data-required]:not([type=file])", function(e) {
  __FORM.clearItemStatus($(this), "addon", "writing");
});



/************************************************
	DESKTOP VALIDATION MESSAGE
  ok or nok
*************************************************/
var form_response_status = getURLParam("m");

//-- if valid status found
if (form_response_status && typeof form_response_status !== "undefined") {

  //-- show modules with the corresponding response status
  if (form_response_status === "ok") {
    $("[data-form-ok]:not([class*=placeholder])").show();
  }
  else if (form_response_status === "nok") {
    $("[data-form-nok]:not([class*=placeholder])").show();
  }
  else {
    showBackendMessages(form_response_status);
  }
}

/************************************************
	COOKIE VALIDATION MESSAGES (server side validation)
  wl_msg_codes
*************************************************/
var wl_msg_codes = Cookies.get("wl_msg_codes");

//-- if messages codes found...
if (typeof wl_msg_codes !== "undefined" && wl_msg_codes) {

  showBackendMessages(wl_msg_codes);
}


/**
 * showBackendMessages - show conf/error messages form server side validation
 * @param {STRING} codes - jquery object of the template (module)
 * @return {VOID} interacts with the DOM
 */
function showBackendMessages(codes) {

  var template_error_desktop = $("[class^=desk_info_icon_text-placeholder][data-type=module][data-form-nok]");
  var template_success_desktop = $("[class^=desk_info_icon_text-placeholder][data-type=module][data-form-ok]");
  var template_error_mobile = $("[class^=mob_info_icon_text-placeholder][data-type=module][data-form-nok] li.target-flag");
  var template_success_mobile = $("[class^=mob_info_icon_text_success-placeholder][data-type=module][data-form-ok]");


  //-- if templates for displaying the errors have been found
  if (template_error_desktop.length || template_success_desktop.length) {

    //-- split codes
    codes = codes.split(",");

    //-- go through them and display associated messages
    for (var i = 0; i < codes.length; i++) {

      //-- go through MESSAGES to find corresponding code
      MESSAGES.forEach(function(m) {

        //-- bool
        var found = false;

        //-- getting a match
        if (m.Message_Code === codes[i] && !found) {

          //-- init
          var message_type = m.Message_Type;

          //-- DISPLAY ERROR DESKTOP
          if (template_error_desktop.length && message_type === "error") {
            insertBackendMessage(template_error_desktop, m);

            //-- special home PAGE ==> open form after error display
            if (PAGE_CODE === "hmp_out") {
              $(".desktop-header .btn-signin").trigger("click");
              $(".mob_hdr_out .menu-toggle").trigger("click");
            }
          }

          //-- DISPLAY CONFIRMATION DESKTOP
          if (template_success_desktop.length && message_type === "success") {
            insertBackendMessage(template_success_desktop, m);
          }


          //-- DISPLAY ERROR MOBILE
          if (template_error_mobile.length && message_type === "error") {
            insertBackendMessage(template_error_mobile, m);
          }

          //-- DISPLAY CONFIRMATION MOBILE
          if (template_success_mobile.length && message_type === "success") {
            insertBackendMessage(template_success_mobile, m);
          }

          found = true;
        }
      });
    }
  }
}


/**
 * insertBackendMessage - show conf/error messages form server side validation
 * @param {OBJECT} template - jquery object of the template (module)
 * @param {OBJECT} msg_obj - MESSAGE item
 * @return {VOID} interacts with the DOM
 */
function insertBackendMessage(template, msg_obj) {
  //-- clone template
  var clone = template.clone();

  //-- insert message in clone
  clone.show().find(".message").html(msg_obj.Val);

  //-- show clone by inserting it after the template
  clone.insertAfter(template);

  console.log(template, msg_obj);
}





/************************************************
   CLASS CORRESPONDANCE WITH FORM STATUS
*************************************************/
var STATUS_TO_CLASS = {
  "writing": { wrapper: "", addon: "icon_writing"},
  "error": { wrapper: "error", addon: "icon_error"},
  "correct": { wrapper: "correct", addon: "icon_correct"},
  "calendar": { wrapper: "", addon: "icon_calendar"},
  "blank": { wrapper: "", addon: ""}
};

/************************************************
   VALID EXTENSIONS FOR FORM UPLOAD
*************************************************/
var VALID_EXTENSIONS = ["pdf", "jpg", "png", "gif"];
